module.exports = __webpack_public_path__ + "static/img/xs3.a8dcf866.png";